export default function downloadFile(name: string, content: BlobPart, mimeType: string) {
  const url = URL.createObjectURL(new Blob([content], { type: mimeType }));
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    link.click();
  } catch (error) {
    URL.revokeObjectURL(url);
    throw error;
  }
  // Keep the URL alive until the browser has started the download.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
